<div style="width:100%; height: 100%; display: flex; flex-direction: column;">
  <div data-testid="data-grid-widget" class="dx-widget noselect" style="display: flex; flex-direction: column; height: 100%;">
    <dx-toolbar data-testid="data-grid-toolbar">
      <dxi-item *ngIf="!filteredExternally" location="before" style="display: flex;">
        <ng-container *ngFor="let filter of gridFilterOptions">
          <div data-testid="data-grid-filter-title" class="filter-title">{{filter.name}}:</div>
          <dx-radio-group data-testid="data-grid-radio-group" [dataSource]="filter.items" layout="horizontal" displayExpr="text" (onValueChanged)="onFilter($event)" [value]="radioGroupValue[filter.name]">
          </dx-radio-group>
        </ng-container>
      </dxi-item>
      <dxi-item *ngIf="!filteredExternally && checkbox1Text && checkbox2Text" location="before">
        <div *dxTemplate style="padding-left: 20px;">
          <dx-check-box data-testid="data-grid-check-box-show-completed" (onValueChanged)="onCheckbox1Changed($event)" [text]="checkbox1Text" [value]="checkbox1Value" [visible]="checkbox1Visible">
          </dx-check-box>
        </div>
      </dxi-item>
      <dxi-item *ngIf="!filteredExternally && checkbox1Text && checkbox2Text" location="before">
        <div *dxTemplate style="padding-left: 20px;">
          <dx-check-box data-testid="data-grid-check-box-show-rejected" (onValueChanged)="onCheckbox2Changed($event)" [text]="checkbox2Text" [value]="checkbox2Value" [visible]="checkbox2Visible">
          </dx-check-box>
        </div>
      </dxi-item>
      <dxi-item *ngIf="!filteredExternally && selectBoxVisible" location="before">
        <div *dxTemplate class="toolbar-select-box-container">
          <div *ngIf="selectBoxLabel" data-testid="data-grid-select-box-label" class="toolbar-select-box-label">{{ selectBoxLabel }}</div>
          <dx-select-box
            data-testid="data-grid-select-box"
            class="toolbar-select-box"
            [items]="selectBoxItems"
            [value]="selectBoxValue"
            [searchEnabled]="false"
            (onValueChanged)="onSelectBoxChanged($event)">
          </dx-select-box>
        </div>
      </dxi-item>
      <dxi-item *ngIf="filteredExternally" location="before">
        <div *dxTemplate style="padding-left: 20px;">
          <div data-testid="data-grid-filtered-externally-message" class="filtered-externally-message">
            {{ filteredExternallyMessage }}
            <dx-button data-testid="data-grid-button" icon="close" (onClick)="onDismissFilteredExternallyMessage()" hint="Dismiss"></dx-button>
          </div>
        </div>
      </dxi-item>
      <dxi-item location="after" *ngIf="showAddNew">
        <div *dxTemplate>
          <dx-drop-down-button data-testid="data-grid-drop-down-button" icon="add" [items]="addNewOptions" keyExpr="id" displayExpr="templateType" (onItemClick)="onAddNew($event)" [dropDownOptions]="addNewDropDownOptions" hint="add new">
          </dx-drop-down-button>
        </div>
      </dxi-item>
    </dx-toolbar>
    <div data-testid="data-grid-fixed-header-grid" class="fixed-header-grid" style="flex: 1; min-height: 0; max-height: calc(100vh - 200px); overflow: hidden; margin-bottom: 5px;">
      <dx-data-grid data-testid="dataGrid" id="dataGrid" #dxDataGrid keyExpr="id" [dataSource]="rowData" [hoverStateEnabled]="true" [rowAlternationEnabled]="true" [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [allowColumnReordering]="true" [allowColumnResizing]="true" columnResizingMode="widget" [columnAutoWidth]="true" (onRowDblClick)="onRowDblClick($event)" (onEditorPreparing)="onEditorPreparing($event)" (onEditorPrepared)="onEditorPrepared($event)" (onRowPrepared)="rowPreparedHandler($event)" (onSaving)="onSaving($event)" (onRowUpdating)="onRowUpdating($event)" (onRowUpdated)="onRowUpdated($event)" (onSelectionChanged)="onSelectionChanged($event)" [focusedRowEnabled]="enableFocusedRow" [focusedRowIndex]="focusedRowIndex" (onEditingStart)="editingStart($event)" (onContentReady)="onContentReady($event)" (onExporting)="onExporting($event)" (onCellPrepared)="onCellPrepared($event)" (onContextMenuPreparing)="onContextMenuPreparing($event)" (onRowClick)="onRowClick($event)" class="small-text-grid" (onOptionChanged)="onOptionChanged($event)" [repaintChangesOnly]="repaintChangesOnly" [highlightChanges]="hightlightChanges" [remoteOperations]="{ sorting: true, filtering: true, paging: true, grouping: true }" [cacheEnabled]="cacheEnabled" (onRowExpanding)="onRowExpanding($event)" (onRowCollapsing)="onRowCollapsing($event)" template="master" [masterDetail]="{
      enabled: hasMasterDetail,
      template: 'masterDetails',
      autoExpandAll: false
    }" style="height: 100%; width: 100%;" showCheckBoxesMode="always">
        <dxo-load-panel [enabled]="false"></dxo-load-panel>
        <dxo-scrolling mode="standard" rowRenderingMode="standard" columnRenderingMode="standard" showScrollbar="onhover" useNative="true">
        </dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-toolbar>
          <dxi-item name="groupPanel"></dxi-item>
          <dxi-item location="after" name="searchPanel"></dxi-item>
          <dxi-item name="columnChooserButton" locateInMenu="auto" location="after" hint="column chooser">
          </dxi-item>
          <dxi-item name="exportButton" locateInMenu="auto" location="after" hint="export to Excel" [visible]="showExportToExcel">
          </dxi-item>
          <dxi-item location="after">
            <dx-button data-testid="data-grid-button-1" [icon]="filterIcon" (onClick)="clearAllFilters()" hint="clear all filters"></dx-button>
          </dxi-item>
          <dxi-item location="after" *ngIf="hasMasterDetail">
            <dx-button data-testid="data-grid-button-2" [icon]="clearIcon" (onClick)="collapseAllGroups()" hint="collapse all"></dx-button>
          </dxi-item>
          <dxi-item location="after">
            <dx-button data-testid="data-grid-button-3" [icon]="resetGridIcon" (onClick)="clearGridState()" hint="clear grid layout"></dx-button>
          </dxi-item>
        </dxo-toolbar>
        <ng-container *ngFor="let summary of summaryConfig"></ng-container>
        <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
        <dxo-editing *ngIf="allowEditing" [allowUpdating]="allowUpdating" [allowAdding]="false" [allowDeleting]="allowDeleting" mode="batch"></dxo-editing>
        <dxo-selection mode="multiple" [allowSelectAll]="true"></dxo-selection>
        <dxo-filter-row [visible]="showFilterRow" applyFilter="auto"></dxo-filter-row>
        <dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
        <dxo-export [enabled]="true" [allowExportSelectedData]="allowExportSelectedRows"></dxo-export>
        <dxo-search-panel [visible]="showSearchPanel" [placeholder]="searchPlaceholder" [width]="350"></dxo-search-panel>
        <ng-container *ngIf="columnData && columnData.length > 0">
          <dxi-column *ngFor="let column of columnData" [dataField]="column.field" [caption]="column.title" [dataType]="column.dataType" [allowEditing]="column.allowEditing" [calculateCellValue]="column.valueCalculator" [setCellValue]="column.setCellValue" [showEditorAlways]="column.showEditorAlways" [allowSearch]="column.allowSearch" [allowFiltering]="column.allowFiltering" [allowSorting]="column.allowSorting !== false" [allowGrouping]="column.allowGrouping !== false" [type]="column.columnType" [showEditorAlways]="column.showEditorAlways" [cellTemplate]="column.cellTemplate" [calculateFilterExpression]="column.calculateFilterExpression" [width]="column.width" [visible]="column.visible !== false" [fixed]="column.fixed" [fixedPosition]="column.fixedPosition">
            <ng-container *ngIf="column.hasCustomFilter">
              <dxo-header-filter [dataSource]="column.filterDataSource"></dxo-header-filter>
            </ng-container>
            <ng-container *ngIf="column.columnType === 'simpleLookup'">
              <dxo-lookup [dataSource]="column.lookupConfig?.dataSource">
              </dxo-lookup>
            </ng-container>
            <ng-container *ngIf="column.dataFormat && column.dataType === 'currency'">
              <dxo-format type="fixedPoint" [precision]="column.precision">
              </dxo-format>
            </ng-container>
          </dxi-column>
          <div *dxTemplate="let cellInfo of 'buttonsTemplate'">
            <ng-container *ngFor="let button of getButtons(cellInfo.data)">
              <div data-testid="data-grid-button-with-badge" class="button-with-badge">
                <dx-button data-testid="data-grid-button-4"
                  [class]="button.cssClass"
                  [hint]="button.hint"
                  [icon]="button.icon"
                  [disabled]="button.disabled"
                  (onClick)="handleButtonClick($event, button, cellInfo.data)">
                </dx-button>
                <span
                  *ngIf="button.id === '1' && cellInfo.data?.unreadCommentCount > 0"
                  class="badge-overlay"
                  [class.large-count]="cellInfo.data.unreadCommentCount >= 10">
                  {{ cellInfo.data.unreadCommentCount }}
                </span>
                <span
                  *ngIf="button.id === '2' && cellInfo.data?.unreadUrlCount > 0"
                  class="badge-overlay badge-overlay-document"
                  [class.large-count]="cellInfo.data.unreadUrlCount >= 10">
                  {{ cellInfo.data.unreadUrlCount }}
                </span>
              </div>
            </ng-container>
          </div>
          <div *dxTemplate="let cellInfo of 'taskDataTemplate'">
            <span [innerHTML]="cellInfo.data?.taskData | formattaskdata:getExistingColumnNames()"></span>
          </div>
          <div *dxTemplate="let cellInfo of 'amountTemplate'">
            <span [ngClass]="getAmountCellClass && getAmountCellClass(cellInfo.data) || ''">{{ currencyFormatter && currencyFormatter(cellInfo.data) || cellInfo.data?.amount || '' }}</span>
          </div>
          <div *dxTemplate="let cellInfo of 'statusTemplate'">
            <span class="status-pill" [ngClass]="getStatusClass(cellInfo.data?.status)">
              {{ cellInfo.data?.status }}
            </span>
          </div>
          <div *dxTemplate="let cellInfo of 'dueDateTemplate'">
            <span class="due-date-pill" [ngClass]="getDueDateClass(cellInfo.data?.dueDate, cellInfo.data)">
              {{ cellInfo.data?.dueDate | date:'shortDate' }}
            </span>
          </div>
          <div *dxTemplate="let cellInfo of 'booleanYesNoTemplate'">
            <span class="boolean-display">
              {{ formatBooleanDisplay(cellInfo) }}
            </span>
          </div>
          <div *dxTemplate="let cellInfo of 'rushJobTemplate'">
            <span class="boolean-display" [ngClass]="{ 'rush-job-badge': isBooleanYes(cellInfo) }" *ngIf="isBooleanYes(cellInfo)">
              {{ formatBooleanDisplay(cellInfo) }}
            </span>
            <span class="boolean-display" *ngIf="!isBooleanYes(cellInfo)">
              {{ formatBooleanDisplay(cellInfo) }}
            </span>
          </div>
          <div *dxTemplate="let cellInfo of 'isUrgentTemplate'">
            <span class="boolean-display" [ngClass]="{ 'urgent-badge': isBooleanYes(cellInfo) }" *ngIf="isBooleanYes(cellInfo)">
              {{ formatBooleanDisplay(cellInfo) }}
            </span>
            <span class="boolean-display" *ngIf="!isBooleanYes(cellInfo)">
              {{ formatBooleanDisplay(cellInfo) }}
            </span>
          </div>
        </ng-container>
        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[20, 50, 100, 200, 300, 500]" [showNavigationButtons]="true" [showInfo]="true" infoText="Page {0} of {1} ({2} items)" [visible]="true">
        </dxo-pager>
        <dxo-paging [pageSize]="20"></dxo-paging>
        <dxo-state-storing [enabled]="true" type="custom" [storageKey]="storageKey" [customLoad]="loadGridState" [customSave]="saveGridState">
        </dxo-state-storing>
        <dxo-group-panel [visible]="groupPanelVisible"></dxo-group-panel>
        <dxo-grouping #expand [autoExpandAll]="autoExpandGroups"></dxo-grouping>
        <dx-context-menu data-testid="data-grid-context-menu" [width]="200" height:auto (onHiding)="onContextMenuHiding($event)" target="#dataGrid">
        </dx-context-menu>
        <dxo-master-detail [enabled]="hasMasterDetail" template="masterDetails">
        </dxo-master-detail>
        <div *dxTemplate="let masterDetailItem of 'masterDetails'">
          <dx-data-grid data-testid="data-grid-data-grid" *ngIf="getChildDetails(masterDetailItem.data)?.length" [dataSource]="getChildDetails(masterDetailItem.data)" (onCellPrepared)="onDetailCellPrepared($event)" (onRowPrepared)="onDetailRowPrepared($event)" (onContextMenuPreparing)="onDetailContextMenuPreparing($event)" (onRowDblClick)="onDetailRowDblClick($event,masterDetailItem.data)" (onRowClick)="onDetailRowClick($event,masterDetailItem.data)" [showColumnHeaders]="true" [showBorders]="true">
            <ng-container *ngFor="let column of childColumnData">
              <dxi-column [dataField]="column.field" [caption]="column.title" [dataType]="column.dataType" [allowEditing]="column.allowEditing" [calculateCellValue]="column.valueCalculator" [setCellValue]="column.setCellValue" [showEditorAlways]="column.showEditorAlways" [type]="column.columnType" [cellTemplate]="column.cellTemplate" [width]="column.width" [fixed]="column.fixed">
                <ng-container *ngIf="column.hasCustomFilter">
                  <dxo-header-filter [dataSource]="column.filterDataSource"></dxo-header-filter>
                </ng-container>
                <ng-container *ngIf="column.columnType === 'simpleLookup'">
                  <dxo-lookup [dataSource]="column.lookupConfig?.dataSource">
                  </dxo-lookup>
                </ng-container>
                <ng-container *ngIf="column.dataFormat && column.dataType === 'currency'">
                  <dxo-format type="fixedPoint" [precision]="column.precision">
                  </dxo-format>
                </ng-container>
              </dxi-column>
            </ng-container>
            <!-- Template for detail grid taskData column -->
            <div *dxTemplate="let cellInfo of 'taskDataTemplate'">
              <span [innerHTML]="cellInfo.data?.taskData | formattaskdata:getExistingColumnNames()"></span>
            </div>
            <!-- Template for detail grid amount column -->
            <div *dxTemplate="let cellInfo of 'amountTemplate'">
              <span [ngClass]="getAmountCellClass && getAmountCellClass(cellInfo.data) || ''">{{ currencyFormatter && currencyFormatter(cellInfo.data) || cellInfo.data?.amount || '' }}</span>
            </div>
            <!-- Template for detail grid status column -->
            <div *dxTemplate="let cellInfo of 'statusTemplate'">
              <span class="status-pill" [ngClass]="getStatusClass(cellInfo.data?.status)">
                {{ cellInfo.data?.status }}
              </span>
            </div>
            <!-- Template for detail grid due date column -->
            <div *dxTemplate="let cellInfo of 'dueDateTemplate'">
              <span class="due-date-pill" [ngClass]="getDueDateClass(cellInfo.data?.dueDate, cellInfo.data)">
                {{ cellInfo.data?.dueDate | date:'shortDate' }}
              </span>
            </div>
            <div *dxTemplate="let cellInfo of 'booleanYesNoTemplate'">
              <span class="boolean-display">
                {{ formatBooleanDisplay(cellInfo) }}
              </span>
            </div>
            <div *dxTemplate="let cellInfo of 'rushJobTemplate'">
              <span class="boolean-display" [ngClass]="{ 'rush-job-badge': isBooleanYes(cellInfo) }" *ngIf="isBooleanYes(cellInfo)">
                {{ formatBooleanDisplay(cellInfo) }}
              </span>
              <span class="boolean-display" *ngIf="!isBooleanYes(cellInfo)">
                {{ formatBooleanDisplay(cellInfo) }}
              </span>
            </div>
            <div *dxTemplate="let cellInfo of 'isUrgentTemplate'">
              <span class="boolean-display" [ngClass]="{ 'urgent-badge': isBooleanYes(cellInfo) }" *ngIf="isBooleanYes(cellInfo)">
                {{ formatBooleanDisplay(cellInfo) }}
              </span>
              <span class="boolean-display" *ngIf="!isBooleanYes(cellInfo)">
                {{ formatBooleanDisplay(cellInfo) }}
              </span>
            </div>
            <div *dxTemplate="let cellInfo of 'truncatedTextTemplate'">
              <span class="truncated-cell-text" [title]="cellInfo.text">{{ cellInfo.text }}</span>
            </div>
            <dxo-paging [enabled]="false"></dxo-paging>
          </dx-data-grid>
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>